const translation = {
	common: {
		addToList: "Добавить в список",
		confirmAction: "Подтвердите действие!",
		confirmed: "Подтверждено",
		done: "Готово",
		save: "Сохранить",
		cancel: "Отменить",
	},
	validation: {
		required: "Это поле обязательно для заполнения",
	},
	months: {
		january: "Января",
		february: "Февраля",
		march: "Марта",
		april: "Апреля",
		may: "Мая",
		june: "Июня",
		july: "Июля",
		august: "Августа",
		september: "Сентября",
		october: "Октября",
		november: "Ноября",
		december: "Декабря",
	},
	banners: {
		addBanner: "Добавить баннер",
		addLargeBanner: "Добавить большой баннер",
		bannerLink: "Ссылка на баннер",
		confirmDelete: "Хотите удалить баннер?",
		confirmSaveBanners: "Вы подтверждаете сохранение баннеров?",
		confirmSaveChanges: "Вы подтверждаете сохранение изменений?",
		confirmSaveText: "Подтвердите сохранение текста",
		description: "Описание",
		displayBanner: "Отображать баннер",
		editBanner: "Редактировать баннер",
		imageAlt: "Выберите изображение",
		noBanners: "Пока нет баннеров",
		photoDeleted: "Фото {{name}} было удалено!",
		recommendedLargeSize:
			"Рекомендуемый размер фото для баннера 1600x600 (расширение файла jpg, jpeg, png)",
		title: "Название",
		errors: {
			invalidUploadData: "Неверные данные логина или названия изображения",
			largeFileName: "Выбранное изображение имеет слишком большое название",
			maxFileSize: "Размер фото не более 0.5 МБ",
			maxResolution: "Максимальное разрешение изображения 1920px x 1280px",
			requiredBanner: "Обязательно загрузите баннер",
			requiredTwoBanners: "Обязательно загрузите два баннера",
			supportedTypes: "Поддерживаемые расширения изображений: jpg, jpeg, png",
			uploadImage: "Ошибка загрузки изображения",
		},
		placeholders: {
			description: "Введите описание баннера",
			title: "Введите название баннера",
		},
	},
	discountProducts: {
		categoriesTitle: "Категории, на которые не применяются скидки",
		confirmSave: "Вы подтверждаете сохранение категорий и товаров?",
		duplicateId: "Данный ID уже есть в списке",
		emptyField: "Пустое поле",
		productsTitle: "Продукты, на которые не применяются скидки",
		placeholders: {
			categoryId: "Введите ID категории",
			productId: "Введите ID товара",
		},
	},
	discounts: {
		deliveryOrder: "На доставку",
		discounts: "Скидки",
		firstOrder: "Первый заказ",
		loyaltySystem: "Система лояльности",
		pickupOrder: "На самовывоз",
		sales: "Акции",
		tabs: {
			banners: "Баннеры",
			discounts: "Скидки",
			promocodes: "Промокоды",
			sales: "Акции",
		},
		form: {
			amount: "Сумма",
			amountDiscount: "Сумма скидки",
			amountDiscountPlaceholder: "Введите сумму скидки",
			confirmSaveChanges: "Вы подтверждаете сохранение изменений?",
			discount: "Скидка",
			discountPercent: "Процент скидки",
			discountPercentPlaceholder: "Введите процент скидки",
			integerOnly: "Только целые числа",
			maxPercent: "Значение должно быть меньше или равно {count}",
			orderAmount: "Введите сумму заказа",
			present: "Подарок",
			productId: "ID товара",
			productIdPlaceholder: "Введите ID товара",
			required: "Поле обязательно для заполнения",
		},
	},
	promocodes: {
		add: "Добавить",
		apply: "Применить",
		applyForDiscountProducts: "Применять для акционных товаров",
		calendarPeriod: "Выбрать период:",
		categoriesExcluded: "Категории, на которые не применяется промокод",
		categoriesExcludedHint: "Список категорий, на которые не применяется промокод",
		code: "Код промокода",
		codePlaceholder: "Введите код промоакции",
		confirmDelete: "Вы подтверждаете удаление {{id}}?",
		create: "Создать промокод",
		description: "Описание",
		descriptionPlaceholder: "Введите описание промоакции",
		discountSystemId: "ID скидки из системы учета",
		discountSystemIdNote:
			"Заполняйте только если точно уверены, что ID правильный (для iiko пример 0a124f13-99b2-41df-b286-4f21e41c4717, для poster 4)",
		duplicateId: "Данный ID уже есть в списке",
		edit: "Редактировать промокод",
		emptyField: "Пустое поле",
		invalidData: "Некорректные данные",
		latinOnly: "Только латинские буквы",
		minOrderAmount: "Минимальная сумма заказа",
		minOrderAmountHint:
			"Минимальная сумма заказа для использования промокода. Если она отсутствует, укажите 0",
		minOrderAmountPlaceholder: "Введите минимальную сумму или 0",
		noPromocodes: "Пока еще нет промокодов",
		productsExcluded: "Продукты, на которые не применяется промокод",
		productsExcludedHint: "Список продуктов, на которые не применяется промокод",
		title: "Промокоды",
		titleField: "Название",
		titlePlaceholder: "Введите название промоакции",
	},
	categoryForPickup: {
		categoriesTitle: "Категории",
		duplicateId: "Данный ID уже есть в списке",
		fetchError: "Ошибка при получении данных:",
		placeholder: "Введите ID категории",
		saveError: "Ошибка при сохранении данных:",
		saveSuccess: "Данные успешно сохранены",
		saveSuccessMessage: "Данные успешно сохранены!",
		stopList: "Стоп-лист",
		tooltip: "Введите ID категории, которую хотите скрыть",
	},
	blackList: {
		addDuplicate: "Такой номер уже есть",
		emptyValue: "Введите значение",
		menuTitle: "Меню",
		numbersTitle: "Номера",
		phonePlaceholder: "Введите номер",
		saveError: "Не удалось обновить черный список:",
		saveSuccessMessage: "Данные успешно сохранены!",
		textPlaceholder: "Введите текст для изменения",
		textTitle: "Текст для черного списка",
	},
	disableAlert: {
		messageStatus: "Состояние сообщения",
		messageText: "Текст сообщения",
		placeholder: "Ваш текст",
		switchLabel: "Включить сообщение",
		updateError: "Ошибка при обновлении данных:",
	},
	disableApp: {
		messageText: "Текст сообщения",
		onApp: "Включить прием заказов",
		onDelivery: "Включить доставку",
		onPickup: "Включить самовывоз",
		placeholder: "Ваш текст",
		title: "Состояние заказов",
	},
	delivery: {
		add: "Добавить",
		addZone: "Добавить зону",
		confirmCreateZone: "Вы подтверждаете создание зоны?",
		confirmDeleteZone: "Вы подтверждаете удаление зоны {{name}}?",
		confirmEditZone: "Вы подтверждаете редактирование зоны?",
		confirmSaveChanges: "Вы подтверждаете сохранение изменений",
		deliveryCost: "Стоимость доставки",
		deliveryItemId: "ID товара доставки",
		editZone: "Редактировать зону",
		freeDelivery: "Бесплатная доставка",
		freeDeliveryFrom: "Бесплатная доставка от",
		minDeliveryAmount: "Минимальная сумма для доставки",
		noZones: "Пока нет созданных зон",
		title: "Условие доставки",
		zoneName: "Название зоны",
		zones: "Зоны",
		placeholders: {
			deliveryCost: "Введите стоимость доставки",
			deliveryItemId: "Введите ID товара доставки",
			freeDeliveryFrom: "Введите сумму мин. доставки",
			minDeliveryAmount: "Введите сумму мин. заказа",
			zoneName: "Введите название зоны",
		},
		validation: {
			deliveryCost: "Введите стоимость доставки",
			deliveryItemId: "Введите ID товара доставки",
			freeDeliveryFrom: "Введите бесплатную доставку",
			minDeliveryAmount: "Введите сумму заказа",
			zoneName: "Введите название",
		},
	},
	deliveryZonesControl: {
		enableZone: "Включить доставку в зоне",
		error: "Что-то пошло не так, попробуйте еще раз",
		minActiveZone: "Минимум одна зона должна быть активна",
		title: "Контроль зон доставки",
	},
	labels: {
		add: "Добавить",
		addLabel: "Добавить лейбл",
		addNewLabel: "Добавить новый лейбл",
		addProductId: "Добавить ID товара",
		backgroundColor: "Цвет фона",
		banner: "Баннер",
		bannerPreview: "Превью баннера",
		bannerText: "Текст баннера",
		delete: "Удалить",
		editLabel: "Редактировать лейбл",
		imageReady: "Изображение готово к загрузке",
		imageRequired: "Изображение обязательно",
		labels: "Лейблы",
		noLabels: "Нет доступных лейблов",
		noText: "Без текста",
		position: "Позиция",
		text: "Текст",
		textColor: "Цвет текста",
		textRequired: "Введите текст баннера",
		uploadBanner: "Загрузка баннера",
		uploadImage: "Загрузить изображение",
		errors: {
			deleteImage: "Ошибка при удалении изображения",
			fileTooLarge: "Файл слишком большой. Максимальный размер - 500KB.",
			imageName: "Ошибка при получении имени изображения с сервера",
			missingFileOrLogin: "file или login не переданы",
			unsupportedFormat: "Неподдерживаемый формат файла. Разрешены: JPG, JPEG, PNG.",
			uploadImage: "Ошибка при загрузке изображения.",
		},
	},
	loadControl: {
		confirmSaveChanges: "Вы подтверждаете сохранение изменений?",
		deliveryInterval: "Интервал времени для доставки (мин)",
		minNumber: "Введите число больше или равно 5",
		pickupInterval: "Интервал времени для самовывоза (мин)",
		title: "Контроль нагрузки",
	},
	menu: {
		categories: "Категории",
		categoryIdPlaceholder: "Введите ID категории",
		duplicateId: "Данный ID уже есть в списке",
		menu: "Меню",
		products: "Товары",
		productIdPlaceholder: "Введите ID товара",
		saveSuccess: "Данные успешно сохранены!",
	},
	menuSort: {
		categories: "Категории",
		confirmSortChange: "Хотите изменить сортировку товаров?",
		copied: "Скопировано",
		copyId: "Копировать ID",
		products: "Товары",
		title: "Сортировка меню",
	},
	payCard: {
		cardPaymentSystem: "Система оплаты картой",
		confirmSaveChanges: "Вы подтверждаете сохранение изменений?",
		title: "Системы оплаты",
		placeholders: {
			merchant: "Введите Merchant",
			merchantDomain: "Введите merchantDomain",
			merchantLogin: "Введите Merchant login",
			merchantSecretKey: "Введите Merchant secret key",
			mobileSdkKey: "Введите Mobile Sdk Key",
			payeeId: "Введите PayeeId",
			privateKey: "Введите Private key",
			publicKey: "Введите Public key",
			secretKey: "Введите Secret key",
			shopId: "Введите shop id",
			yandexMoney: "Введите Yandex Money",
		},
	},
	pickupControl: {
		enablePickupAt: "Включить самовывоз на",
		error: "Что-то пошло не так, попробуйте еще раз",
		minActiveTerminal: "Минимум один терминал должен быть активен",
		title: "Контроль точек самовывоза",
	},
	products: {
		add: "Добавить",
		addCategory: "Добавить категорию",
		addProduct: "Добавить товар",
		addProductFirst: "Сначала добавьте товар на {{language}} языке",
		category: "Категория",
		chooseCategory: "Выберите категорию",
		chooseCity: "Выберите город из списка",
		chooseTerminal: "Выбор заведения",
		confirmSortChange: "Хотите изменить сортировку товаров?",
		copy: "Копировать",
		copied: "Скопировано",
		copyCategoryId: "Копировать ID категории {{id}}",
		delete: "Удалить",
		deleteCategoryConfirm: "Вы хотите удалить категорию {{name}}?",
		deleteCategoryProductsConfirm:
			"При удалении категории будут удалены все товары! Удалить?",
		deleteProductConfirm: "Вы хотите удалить товар {{name}}?",
		description: "Описание",
		display: "Отображать",
		differentPrices: "Разные цены в заведениях",
		edit: "Редактировать",
		editCategory: "Редактировать категорию",
		errorTryAgain: "Ошибка, попробуйте еще раз!",
		hide: "Скрыть",
		integerOnly: "Поддерживаются только целые числа",
		maxPhotoSize: "Размер фото не более 0.5 МБ",
		menuLanguage: "Язык меню",
		name: "Название",
		nameField: "Наименование",
		newPhoto: "Новое фото",
		noCategories: "Категорий пока что нет",
		noDescription: "Описание отсутствует",
		noAccess: "У вас нет доступа",
		photo: "Фото",
		price: "Цена",
		saveError: "Произошла ошибка, попробуйте еще",
		shop: "Заведение:",
		showMore: "Показать больше",
		sortMode: "Режим сортировки",
		unsupportedImageFormat: "Данный формат изображения не поддерживается",
	},
	promotion: {
		advertisingText:
			"Кроме рекламы приложения на собственном сайте, вы можете дать прямые ссылки на приложение в ваших группах в социальных сетях: instagram, vk, facebook.",
		advertisingTitle: "Как еще прорекламировать приложение?",
		copy: "Скопировать",
		copied: "Текст был успешно скопирован!",
		downloadQr: "Скачать QR код",
		enableStoreBadges: "Включить значки AppStore & Google Play",
		insertCodeTitle: "Код для вставки сайта",
		qrDoorSize: "Входная дверь - 20 см по длинной стороне.",
		qrMenuSize: "Обложка меню - 5 см по длинной стороне.",
		qrParagraph1:
			"Если навести включенную камеру телефона на QR-код, система предложит вам перейти по ссылке и скачать мобильное приложение. Это самый быстрый способ найти приложение в AppStore или Google Play.",
		qrParagraph2:
			"Наклейку можно разместить на входе в заведение, на обложке меню, на стойках столов или в любом другом видном месте. Наклейка выглядит современно и значительно повышает количество скачиваний приложения.",
		qrParagraph3:
			"Формат, который мы предлагаем для скачивания, подойдет для любой типографии или студии печати. Просто передайте ссылку типографии и закажите нужный объем наклеек.",
		qrRecommendedSizes: "Рекомендуемые размеры:",
		qrStickerTitle: "QR-код для наклейки",
		scriptPlacement:
			"Этот скрипт нужно вставить на сайт между тегами <head></head>.",
		scriptVisitors:
			"Все посетители сайта увидят, что у вас появилось мобильное приложение.",
		title: "Продвижение",
	},
	push: {
		allUsers: "Отправить всем",
		audience: "Аудитория",
		city: "Город",
		confirmSend: "Вы подтверждаете отправку push-уведомления?",
		favorite: "Избранное",
		favorites: "Избранные",
		hiddenText: "Скрытый текст",
		invalidPhone: "Невалидный номер телефона",
		maxPhoneLength: "Максимальная длина номера - 14 цифр, текущий - {{count}} цифр",
		messagePlaceholder: "Введите текст сообщения",
		minPhoneLength: "Минимальная длина номера - 11 цифр, текущий - {{count}} цифр",
		phoneFormat: "Номер в формате:",
		phonePlaceholder: "Номер телефона",
		phoneRequired: "Введите номер телефона",
		productLink: "С переходом на товар",
		productPlaceholder: "Введите id товара",
		send: "Отправить",
		sendError: "При отправке произошла ошибка, попробуйте еще раз!",
		sendSuccess: "Ваше уведомление успешно отправлено!",
		title: "Отправить Push-уведомление",
		text: "Текст",
		ukrainePhone: "Украина: 380501234567",
		russiaPhone: "Россия: 79201234567",
		usersHint:
			"Добавьте номера телефонов, чтобы отправить уведомление конкретным пользователям, либо оставьте список пустым, если хотите отправить push-уведомление всем пользователям.",
		usersList: "Список пользователей:",
		validation: {
			cityRequired: "Необходимо выбрать город",
		},
		selectCity: "Выберите город",
	},
	reviews: {
		callCenter: "Работа Call-центра:",
		comment: "Комментарий:",
		date: "Дата:",
		day: "День",
		deliveryQuality: "Качество доставки:",
		highGrade: "Самая высокая оценка",
		impression: "Общее впечатление:",
		loadMore: "Показать еще",
		loadMoreDays: "Показать еще 7 дней",
		lowGrade: "Самая низкая оценка",
		month: "Месяц",
		newest: "Самые новые",
		noReviews: "У вас еще нет отзывов!",
		oldest: "Самые старые",
		period: "Период:",
		phone: "Номер телефона:",
		productQuality: "Качество товара:",
		sort: "Сортировать",
		sortWithColon: "Сортировать:",
		title: "Отзывы",
		week: "Неделя",
		impressions: {
			negative: "негативное 🤬",
			neutral: "нейтральное 😐",
			positive: "позитивное 😍",
		},
	},
	workTime: {
		confirmSaveChanges: "Вы подтверждаете сохранение изменений",
		deliveryInterval: "Интервал времени для доставки (мин)",
		infoMessage: "Информационное сообщение",
		maxTime: "Максимальное время",
		maxWorkTime: "Максимальное время работы заведения",
		messagePlaceholder: "Введите текст...",
		minEstablishment: "Минимальное время заведения",
		minTime: "Минимальное время",
		pickupInterval: "Интервал времени для самовывоза (мин)",
		title: "Время работы",
	},
	defaultScreen: {
		logout: "Выйти",
		navigation: {
			addProduct: "Добавить товар",
			blacklist: "Черный список",
			cardPayment: "Оплата картой",
			categories: "Категории",
			deliveryTerms: "Условия доставки",
			deliveryZones: "Зоны доставки",
			disableOrders: "Отключить заказы",
			disablePickup: "Отключить самовывоз",
			editProduct: "Редактировать товар",
			labels: "Лейблы",
			leaveDescription: "Ваши данные не будут сохранены.",
			leaveTitle: "Вы хотите уйти?",
			loadControl: "Контроль нагрузки",
			loginMessage: "Сообщение при входе",
			loyaltySystem: "Система лояльности",
			menu: "Меню",
			menuFilling: "Заполнение меню",
			pickupCategories: "Категории самовывоза",
			products: "Товары",
			promotion: "Продвижение",
			push: "Push-уведомление",
			reviews: "Отзывы",
			settings: "Настройки",
			sortMode: "Режим сортировки",
			stopList: "Стоп-лист",
			stopListSorting: "Стоп-лист/сортировка",
			workingHours: "Время работы",
		},
	},
	language: {
		label: "Язык",
		en: "Анг",
		ru: "Рус",
		uk: "Укр",
	},
};

export default translation;
